import Order from "./modules/OrderVuex";

export default {
  Order
}